module.exports = ".flex-shrink-11{flex-shrink:11}.ellipsis{white-space:nowrap;overflow:hidden;text-overflow:ellipsis}"